class LoginModalStore {
	#visibility = $state(false);

	get visibility() {
		return this.#visibility;
	}

	set visibility(value: boolean) {
		this.#visibility = value;
		console.log('loginModal#visibility changed', this.#visibility);
	}

}

export const loginModalStore = new LoginModalStore();
